import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { observer } from "mobx-react";
import SequenceTemplateData from "Stores/sequence/SequenceTemplateData";
import CreateNewSeqImg from "Assets/png/createNewSeq.png";
import SelectTemplateImg from "Assets/png/selectTemplate.png";
import GenerateAISeqImg from "Assets/png/generateAI.png";
import CreateSequence from "./CreateSequence";
import { seqTemplatePopupState } from "./SeqTemplatePopupState";
import PredefinedTemplates from "./PredefinedTemplates";
import TitleBadge from "./TitleBadge";
import TemplateSelectedStages from "./TemplateSelectedStages";
import GenerateAISequence from "./GenerateAISequence";
import userDetail from "Stores/userDetail";
import PaywallUtils from "Utils/PaywallUtils";
import { linkedInTemplatePopupState } from "../LinkedInTemplatePopupState";
import { ReactComponent as EmailTempIcon } from "Assets/svg/templates/emailTempIcon.svg";
import { ReactComponent as LinkedInTempIcon } from "Assets/svg/templates/linkedinTempIcon.svg";
import { ReactComponent as RightArrowIcon } from "Assets/svg/linkedinTemplate/rightArrowIcon.svg";

const SeqTemplateSection = props => {
  const {
    className = "",
    label = "",
    subLabel = "",
    img = "",
    children = <></>,
    showPanel = false,
    ...remainingProps
  } = props || {};

  return (
    <section className={className} {...remainingProps}>
      <div className={`${className}Item ${showPanel ? "showPanel" : ""}`}>
        <img src={img} alt={label} className="seqTemplateImg" />
        <p className={"seqTemplateLabel"}>{label}</p>
        <p className={"seqTemplateSubLabel"}>{subLabel}</p>
      </div>
      {children}
    </section>
  );
};

const SeqTemplateItem = observer(props => {
  const {
    closePopup = "",
    showUpgrade = "",
    keyVal = "",
    ...remainingProps
  } = props || {};
  const [showPanel, setShowPanel] = useState(false);
  const [sequenceName, setSequenceName] = useState("");
  const {
    inFreePlan = false,
    planName = "",
    writingAssistantEnabled = false
  } = userDetail.userFeatureFlag || {};

  const onMouseEnter = () => {
    setShowPanel(true);
  };

  const onMouseLeave = () => {
    setShowPanel(false);
  };

  const onClick = () => {
    if (keyVal === "generateAISequence" && !writingAssistantEnabled) {
      PaywallUtils.upgradeUtilsFunction(
        "AIWritingSeq",
        false,
        planName,
        inFreePlan
      );
    } else {
      seqTemplatePopupState.setAction(keyVal);
      if (keyVal === "linkedInTemplates") {
        linkedInTemplatePopupState.setShowTemplatesListPopup(true);
      }
    }
  };

  return keyVal === "createNewSeq" ? (
    <SeqTemplateSection
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...remainingProps}
      key={keyVal}
      showPanel={showPanel || sequenceName}
    >
      <CreateSequence
        close={closePopup}
        showUpgrade={showUpgrade}
        setSequenceName={setSequenceName}
        sequenceName={sequenceName}
        className={showPanel || sequenceName ? "showPanel" : ""}
      />
    </SeqTemplateSection>
  ) : (
    <SeqTemplateSection onClick={onClick} {...remainingProps} />
  );
});

const SequenceTemplatePopup = observer(props => {
  const { seqNameCancelAction = () => { }, showUpgrade = () => { } } =
    props || {};

  const seqTemplateConfig = [
    {
      keyVal: "createNewSeq",
      label: "Create new",
      subLabel: "Create a new sequence from scratch",
      className: "createNewSeq",
      img: CreateNewSeqImg
    },
    {
      keyVal: "selectTemplates",
      label: "Select Templates",
      subLabel: `Start with Salesgear's Pre-built templates`,
      className: "selectTemplate",
      img: SelectTemplateImg
    },
    {
      keyVal: "generateAISequence",
      label: "Generate AI Sequence",
      subLabel: "Use AI to generate a sequence automatically",
      className: "generateAISequence",
      img: GenerateAISeqImg
    }
  ];

  const closePopup = async () => {
    seqNameCancelAction();
    seqTemplatePopupState.setAction("");
    SequenceTemplateData.setSeqTemmplateClicked(false);
    seqTemplatePopupState.setProgressBarState(1);
    seqTemplatePopupState.setShowLottie(false);
    seqTemplatePopupState.setGenerateAISeqValue({});
    seqTemplatePopupState.setHasDomainChange(false);
    await seqTemplatePopupState.getDomain();
  };

  const handleProgressBarClick = index => {
    if (index === 1) {
      SequenceTemplateData.setSeqTemmplateClicked(false);
    }
  };

  const [createAction, setCreateAction] = useState(null);

  const handleCreate = () => {
    if (createAction) {
      createAction();
    }
  };

  if (seqTemplatePopupState.selectedTemplateType === "linkedin") return null;

  return seqTemplatePopupState?.action === "selectTemplates" ? (
    <div className="predefinedSequenceSection">
      <div
        className={`card animated customzoomIn ${!seqTemplatePopupState.selectedTemplateType
          ? "typeSelectionCard"
          : seqTemplatePopupState.selectedTemplateType === "email"
            ? "unifiedTemplateCard"
            : ""
          }`}
      >
        <i
          id="closeSequenceTemplatePopup"
          className="material-icons"
          onClick={() => closePopup()}
        >
          close
        </i>
        {!seqTemplatePopupState.selectedTemplateType ? (
          <>
            <div className="sequenceTemplatePopupHeader">
              <TitleBadge title="Sequence Template Library" showDesc={true}>
                <span>Browse templates by category and choose one to customize</span>
              </TitleBadge>
            </div>
            <div className="templateTypeSelection">
              <div
                className="typeCard"
                onClick={() => {
                  seqTemplatePopupState.setSelectedTemplateType("email");
                  if (SequenceTemplateData.predefinedTemplateList?.length > 0) {
                    SequenceTemplateData.setSelectedPredefinedTemplate(SequenceTemplateData.predefinedTemplateList[0]);
                  }
                }}
              >
                <div className="typeIcon">
                  <EmailTempIcon />
                </div>
                <p className="typeLabel">Email</p>
                <div className="arrowBtn">
                  <RightArrowIcon />
                </div>
              </div>
              <div
                className="typeCard"
                onClick={() => {
                  seqTemplatePopupState.setSelectedTemplateType("linkedin");
                  linkedInTemplatePopupState.setShowTemplatesListPopup(true);
                }}
              >
                <div className="typeIcon">
                  <LinkedInTempIcon />
                </div>
                <p className="typeLabel">LinkedIn</p>
                <div className="arrowBtn">
                  <RightArrowIcon />
                </div>
              </div>
            </div>
          </>
        ) : SequenceTemplateData.seqTemplateClicked && seqTemplatePopupState.selectedTemplateType !== "email" ? (
          <TemplateSelectedStages
            close={closePopup}
            showUpgrade={showUpgrade}
          />
        ) : seqTemplatePopupState.selectedTemplateType === "email" ? (
          <div className="predefinedTemplateUnifiedContainer">
            <div className="sequenceTemplatePopupHeader">
              <div className="titleBackBtn">
                <TitleBadge title="Predefined Sequence" showDesc={true}>
                  <span>Select from our predefined sequences and customize</span>
                </TitleBadge>
              </div>
            </div>
            <div className="templatesContentSplit">
              <div className="templatesListSide">
                <PredefinedTemplates />
              </div>
              <div className="templatePreviewSide">
                <TemplateSelectedStages
                  close={closePopup}
                  showUpgrade={showUpgrade}
                  isSidePanel={true}
                  setCreateAction={setCreateAction}
                />
              </div>
            </div>
            <div className="sequenceTemplatePopupFooter">
              <button
                className="backBtn"
                onClick={() => {
                  seqTemplatePopupState.setSelectedTemplateType("");
                  SequenceTemplateData.setSelectedPredefinedTemplate(null);
                  SequenceTemplateData.setSeqTemmplateClicked(false);
                }}
              >
                Back
              </button>
              <button
                className="useTemplateBtn"
                onClick={handleCreate}
              >
                {linkedInTemplatePopupState.targetSequenceId ? "Use Template" : "Create And Customize"}
              </button>
            </div>
          </div>
        ) : null}
      </div>
      <div className="overlayMaskPopup"></div>
    </div>
  ) : seqTemplatePopupState?.action === "generateAISequence" ? (
    <div className="generateAISequenceSection">
      <div className="card animated customzoomIn">
        <GenerateAISequence closePopup={closePopup} />
      </div>
      <div className="overlayMaskPopup"></div>
    </div>
  ) : (
    <div
      className="sequenceTemplatePopupSection"
      id="sequencePredefinedTemplatePopup"
    >
      <div className="card animated customzoomIn typeSelectionCard">
        <div className="sequenceTemplatePopupHeader">
          <h2 className="createSequenceTitle">Create sequence</h2>
          <i
            id="closeSequenceTemplatePopup"
            className="material-icons"
            onClick={() => closePopup()}
          >
            close
          </i>
        </div>
        <div className="sequenceTemplatePopupContent">
          {seqTemplateConfig?.map(item => (
            <SeqTemplateItem
              {...item}
              key={item?.key}
              closePopup={closePopup}
              showUpgrade={showUpgrade}
            />
          ))}
        </div>
      </div>
      <div className="overlayMaskPopup"></div>
    </div>
  );
});

export { SequenceTemplatePopup };
export default withRouter(SequenceTemplatePopup);
